import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'irpTimer',
})
export class TimerPipe implements PipeTransform {
  transform(seconds: number, from?: number): string {
    const minutes: number = Math.floor(seconds / 60);
    return ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(seconds - minutes * 60)).slice(-2);
  }
}
